<template>
  <div class="fade-in">
    <div class="selfie-error-content">
      <div class="help-img">
        <Asset
          name="man-help.svg"
          alt="Homem segurando documento"
          title="Homem segurando documento"
        />
      </div>

      <div class="help-warning">
        <Icon name="filled-warning"/>
        <p>Fique atento aos itens abaixo antes de reenviar a foto</p>
      </div>

      <div class="help-itens">
        <div class="help-item">
          <Icon name="hand-with-document"/>
          <p>Segure o documento</p>
        </div>

        <div class="help-item">
          <Icon name="glasses-help"/>
          <p>Retire os óculos</p>
        </div>

        <div class="help-item">
          <Icon name="sun-help"/>
          <p>Vá para um ambiente com melhor iluminação</p>
        </div>
      </div>
    </div>

    <div class="help-button">
      <Button class="primary" @click="actionEvent">
        <Icon name="camera"/>
        <span>Tirar foto novamente</span>
      </Button>
    </div>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';
import Icon from '@/components/ui/AppIcon.vue';
import Button from '@/components/ui/AppButton.vue';

export default {
  name: 'onboarding-selfie-error',
  components: { Asset, Icon, Button },
  data: () => ({
    helpOpened: false,
  }),
  methods: {
    actionEvent() {
      this.$router.replace({
        name: 'onboarding-selfie-camera',
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .help-img {
    background: var(--warning-light);
    img {
      width: 100%;
    }
  }

  .help-warning {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 16px 24px;

    background: var(--warning-light);
    color: var(--warning-dark);

    img {
      align-self: flex-start;
      margin-right: 16px;
      margin-top: 4px;
    }

    p {
      font-size: 18px;
      line-height: 26px;
    }
  }

  .help-itens {
    margin: 20px 24px;

    .help-item {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      p {
        @extend .body-regular;
        margin-left: 16px;
      }

      img {
        width: 48px;
      }
    }
  }

  .help-button {
    margin: 20px 24px;

    button {
      width: 100%;
      height: 48px;
    }
    span {
      padding-left: 8px;
    }
  }
</style>
